import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import * as queryString from 'query-string';
import { Alert } from '@surfline/quiver-react';
import { register } from '../../redux/actions/user';
import { navigatedToPage, trackEvent } from '../../redux/actions/segmentEvents';
import { CreateForm, FacebookLogin } from '../../components';
import en from '../../international/translations/en';

class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFavoritesAlert: false,
    };
    this.props.doNavigatedToPage('Create Account', 'Authentication');
  }

  componentDidMount() {
    if (this.props.queryString) {
      const queryParams = queryString.parse(this.props.queryString);
      sessionStorage.setItem('redirectUrl', queryParams.redirectUrl);
      if (queryParams && queryParams.alert === 'noAuthFav') {
        this.setFavoritesAlert();
      }
    }
  }

  // This is just a band-aide.
  setFavoritesAlert() {
    this.setState({
      showFavoritesAlert: true
    });
  }

  submitForm = async (values) => {
    const { doSubmitRegister } = this.props;
    await doSubmitRegister(values);
  }

  render() {
    const formLocation = 'register';
    const meta = [
      { name: 'description', content: en.create.meta_description }
    ];
    const {
      submitting,
      submitSuccess,
      geo
    } = this.props;
    return (
      <div className="create__container">
        <div className="create__card">
          {this.state.showFavoritesAlert && (
            <Alert
              style={{ textAlign: 'center', margin: '0 0 20px 0' }}
            >
              {en.create.onboarding_alert_nofav}
            </Alert>
          )}
          <h1 className="create__title">{en.create.title}</h1>
          <p>
            {'Already have an account? '}
            <Link
              to="/sign-in"
              onClick={() => trackEvent('Create Account Form Clicked Sign In', 'register')}
            >
              {'  Sign In'}
            </Link>
          </p>
          <Helmet
            title={en.create.meta_title}
            meta={meta}
          />
          <FacebookLogin formLocation={formLocation} />
          <CreateForm
            submitting={submitting}
            submitSuccess={submitSuccess}
            formLocation={formLocation}
            submitFunc={this.submitForm}
            geo={geo}
          />
        </div>
      </div>
    );
  }
}

Create.propTypes = {
  queryString: PropTypes.string,
  submitSuccess: PropTypes.bool.isRequired,
};

Create.defaultProps = {
  queryString: null,
};

export default connect(
  state => ({
    queryString: state.routing.location.search,
    submitting: state.interactions.submitting,
    submitSuccess: state.user.submitSuccess,
    geo: state.geo,
  }),
  dispatch => ({
    doSubmitRegister: values => dispatch(register(values)),
    doNavigatedToPage: (name, category) => dispatch(navigatedToPage(name, category)),
    initialize
  })
)(Create);
